import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';

import AddDefecation from './AddDefecation';
import {
  isEnableLoadingSelector,
  defecationListSelector,
} from './selector';
import { deleteDefecation, getDefecationList, refreshDefecationList } from './thunk';

import type { TableBaseColumnType, TableBaseRowType } from '@/components/TableBase/Body';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { DefecationJson } from '@/types/domain/defecation/entities/defecationEntity';
import type { UserType } from '@/types/domain/user/redux';

import AdditionalLoading from '@/components/AdditionalLoading';
import Delete from '@/components/Delete';
import TableBase from '@/components/TableBase';
import DefecationInfo from '@/domain/defecation/component/DefecationInfo';
import { MeasureDateTime } from '@/domain/temperature/service/entity/valueObjects/measureDateTime';
import { toStringDateTimeDisplay } from '@/utils/date';

/**
 * プロパティ
 */
export type Props = {
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
};

const Defecation: React.FC<Props> = ({ user, child, facilityList }) => {
  const dispatch = useDispatch();
  const isEnableLoading = useSelector(isEnableLoadingSelector);
  const [
    isOpen,
    setIsOpen,
  ] = React.useState<boolean>(false);
  const defecationList = useSelector(
    defecationListSelector,
  );
  const [
    deleteDefecationJson,
    setDeleteDefecationJson,
  ] = React.useState<DefecationJson | undefined>(undefined);
  const rows: TableBaseRowType[] = [];
  for (let i = 0; i < defecationList.length; i += 1) {
    if (defecationList[i].data.childId === child.childId) {
      rows.push({
        id: i.toString(),
        measureDateTime: toStringDateTimeDisplay(
          new Date(defecationList[i].data.measureDateTime),
          false,
        ),
        defecationCategory: defecationList[i].data.defecationCategory,
        type: defecationList[i].data.measurerType,
      });
    }
  }
  const columns: TableBaseColumnType[] = [
    { id: 'measureDateTime', label: MeasureDateTime.label, minWidth: 110 },
    { id: 'defecationCategory', label: '種類', minWidth: 20 },
  ];
  const actions = [];
  actions.push({
    icon: <DeleteIcon />,
    title: '削除',
    action: (r: TableBaseRowType) => {
      const item = defecationList[parseInt(r.id, 10)];
      setDeleteDefecationJson(item);
    },
    disabled: (r: TableBaseRowType) => r.type !== 'app',
  });
  return (
    <div>
      <div>
        <TableBase
          rows={rows}
          columns={columns}
          actions={actions}
          addAction={() => setIsOpen(true)}
          refreshAction={() => dispatch(refreshDefecationList())}
          isPagination={false}
          isShowFilter={false}
          isShowFooter={false}
        />
        <AdditionalLoading
          isEnableLoading={isEnableLoading}
          onClick={() => dispatch(getDefecationList())}
        />
        <AddDefecation
          isOpen={isOpen}
          close={() => setIsOpen(false)}
          user={user}
          child={child}
          facilityList={facilityList}
        />
        <Delete<DefecationJson>
          comp={DefecationInfo}
          data={deleteDefecationJson}
          onDelete={(json) => {
            if (json) {
              dispatch(deleteDefecation({
                data: json,
                facilityIds: facilityList.map((v) => v.data.facilityId),
              }));
            }
            setDeleteDefecationJson(undefined);
          }}
          title="排泄記録"
          content="以下の記録を削除しますか？"
        />
      </div>
    </div>
  );
};

export default Defecation;
